import React from 'react';
import classnames from 'classnames';
import { controls, Media, Player } from 'custom_modules/react-media-player';
import PlayPause from './utils/PlayPause';


const { SeekBar, Duration } = controls;

export default React.forwardRef( ( {
  className, src, onPlay,
}, ref ) => (
  <Media>
    <div className={classnames( 'media audio-player', className )}>
      <div className="media-player">
        <Player
          src={src}
          onPlay={onPlay}
        />
      </div>
      <PlayPause ref={ref} disabled={!src} />
      <SeekBar disabled={!src} />
      <Duration />
    </div>
  </Media>
) );
